import styled from "styled-components";
import { styled as styledMui } from "@mui/material";

export const HeaderContainer = styledMui("header")<{
  hideHeader?: boolean;
  isFixed?: boolean;
}>`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: ${(props) => (props.isFixed ? "fixed" : "static")};
  z-index: ${(props) => (props.hideHeader ? "0" : "900")};
  background-color: ${(props) => props.theme.palette.background.MuiNavigation};
`;

export const TopHeader = styledMui("div")`
  padding: 20px 0;
  background-color: ${(props) => props.theme.palette.background.MuiHeader};
  display: flex;
  justify-content: space-between;
  height: 90px;
  z-index: 10;

  .logo-link {
    div {
      height: 48px;
    }
  }
`;

export const InfoHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const FilterCollapse = styledMui("div")(({ theme }) => ({
  position: "absolute",
  top: "48px",
  right: "0",
  background: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: "10px 10px 30px rgba(0, 0, 0, 0.7)",
  width: "289px",
  borderRadius: "8px",
  zIndex: 5,
  padding: "0 16px",
  maxHeight: "450px",
  overflowY: "auto",

  ".MuiListItem-root": {
    borderTop: 0,
    "&:not(:last-of-type)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },

  ".MuiListItemButton-root": {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));
